import {connect} from 'react-redux';
import ReviewersList, {ReviewersListProps} from './ReviewersList';
import SimpleReviewerModel from '../../types/SimpleReviewerModel';
import ReduxState from '../../types/ReduxState';

const mapStateToProps = (state: ReduxState, ownProps: ReviewersListContainerProps): Partial<ReviewersListProps> => {
   return {
      users: state.users || {},
      isOwner: ownProps.isOwner,
      reviewers: ownProps.reviewers,
      cancelRemoveReviewer: ownProps.cancelRemoveReviewer,
      removeReviewer: ownProps.removeReviewer,
      themeName: state.themeName,
      notifyReviewer: ownProps.notifyReviewer,
      modalState: state.modalState
   };
};

export default connect(mapStateToProps, null)(ReviewersList);

interface ReviewersListContainerProps {
   isOwner: boolean;
   reviewers: SimpleReviewerModel[];
   cancelRemoveReviewer(reviewer: SimpleReviewerModel): void;
   removeReviewer(reviewer: SimpleReviewerModel): void;
   notifyReviewer(reviewer: SimpleReviewerModel, wantToNotify: boolean): void;
}
